import React from 'react';
import { Box, Typography } from '@mui/material';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import { Button } from '../../../Components/MUIs';

export default function RemoveContactBottomSheet({
  contact,
  onClose,
  onConfirm,
  isLoading = false,
}) {
  const name = contact?.manageName || '해당 연락처';

  return (
    <BottomSheet
      onDismiss={onClose}
      isHeaderChildren
      headerText=""
      headerChildren={
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          비상연락망 해제
        </Typography>
      }
    >
      <Box sx={{ px: 1 }}>
        <Typography sx={{ color: '#918A8A', pb: 0.5 }}>
          <Box component="span" sx={{ fontWeight: 600, color: '#3A3A3A' }}>
            {name}
          </Box>
          님을 비상연락망에서 해제하시겠습니까?
        </Typography>
      </Box>
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          display: 'flex',
          gap: 1,
          pb: 'calc(8px + env(safe-area-inset-bottom, 0px))',
        }}
      >
        <Button
          name="취소"
          disabled={isLoading}
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: 'transparent',
            border: '1px solid #776D6D',
            color: '#776D6D',
            boxShadow: 'none',
          }}
          onClick={onClose}
        />
        <Button
          name="해제"
          disabled={isLoading}
          sx={{
            width: '100%',
            height: 36,
            borderRadius: '5px',
            backgroundColor: '#57B84D',
            color: '#fff',
            boxShadow: 'none',
          }}
          onClick={onConfirm}
        />
      </Box>
    </BottomSheet>
  );
}
